var addressList = {
  province_list: {
      110101: '北京市',
      120111: '内蒙古自治区',
      130112: '黑龙江省',
      140113: '吉林省',
      150115: '辽宁省',
      160116: '河北省',
      170117: '天津市',

      210202: '海南省',
      220221: '广东省',
      230222: '广西壮族自治区',
      240223: '云南省',
      250225: '贵州省',
      260226: '湖南省',
      270227: '江西省',

      310303: '山东省',
      320331: '江苏省',
      330332: '上海市',
      340333: '浙江省',
      350335: '福建省',
      360336: '安徽省',

      410405: '河南省',
      420451: '山西省',
      430452: '陕西省',
      440453: '宁夏回族自治区',
      450455: '甘肃省',
      460456: '湖北省',

      510506: '四川省',
      520561: '重庆市',
      530562: '新疆维吾尔自治区',
      540563: '青海省',
      550565: '西藏自治区',

      610607: '香港特别行政区',
      620671: '澳门特别行政区',
      630672: '台湾省',

      710708: '泰国',
      720781: '印度',
      730782: '马来西亚',
      740783: '新西兰',
      750785: '新加坡',
      760786: '缅甸',
      770787: '朝鲜',
      
      810809: '美国',
      820891: '日本',
      830892: '韩国',
      840893: '英国',
      850895: '法国',
      860896: '德国',
      870897: '俄罗斯',
    },
  };
  export default  addressList;